<template>
    
    <main class="">
        <div class="">
            <professional></professional>
        </div>
    </main>
</template>
<script>
import professional from '@/components/publications/professional.vue'
export default {
    components: {
        professional,  
    }, 
}
</script>